import React, { useEffect } from "react";
import { FaServicestack } from "react-icons/fa";
import { motion } from "framer-motion";
import { CgClose } from "react-icons/cg";
import { BsGlobe, BsCircleFill } from "react-icons/bs";
import { ImSpinner9 } from "react-icons/im";
import { useState } from "react";
import { ServicesInfo } from "../../constants";

const MyServices = ({ theme }) => {
  const box = document.querySelector(".box");
  const [servicesItem, setServicesItem] = useState("");
  const [includedInfo, setIncludedInfo] = useState([]);
  const [categoriesInfo, setCategoriesInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  // ===================== handleBoxPopup Open Start here ====================
  const handleBoxOpen = (item) => {
    box.style.display = "flex";
    setServicesItem(item);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // ===================== handleBoxPopup Open End here ======================
  // ===================== handleBoxPopup Close Start here ===================
  const handleBoxClose = () => {
    box.style.display = "none";
  };
  // ===================== handleBoxPopup Close End here =====================
  useEffect(() => {
    const box = document.querySelector(".box");
    const boxArea = document.querySelector(".boxArea");
    document.addEventListener("mousedown", (e) => {
      if (boxArea.contains(e.target)) {
        box.style.display = "flex";
      } else {
        box.style.display = "none";
      }
    });
  }, [loading]);

  // ================= includedInfo& categoriesInfo  data Start here =================
  useEffect(() => {
    async function ServicesData() {
      let data = await servicesItem.servicesIncluded;
      let dataTwo = await servicesItem.servicesCategories;
      setIncludedInfo(data);
      setCategoriesInfo(dataTwo);
    }
    ServicesData();
  }, [servicesItem]);
  // ================= includedInfo& categoriesInfo  data End here ==================

  return (
    <div
      className={`py-20 flex flex-col gap-5 border-b-[1px] ${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      }`}
    >
      <h3
        className={`text-[32px] flex flex-row justify-center lgl:justify-start items-center gap-4 text-center lgl:text-left ${
          theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
        } font-bold`}
      >
        My Services
        <span>
          <FaServicestack className="text-4xl text-iconColor" />
        </span>
      </h3>
      <div className="w-full text-white grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 place-content-center gap-10 lgl:gap-4 xl:gap-10 mt-8">
        {ServicesInfo.map((item) => (
          <div
            onClick={(e) => handleBoxOpen(item)}
            key={item._id}
            className={`${
              theme === "dark"
                ? "text-darkTextColor bg-[#050E27] border-[#0A1437]"
                : "text-lightTextColor bg-[#D2d9f3] border-gray-300"
            } w-full h-[400px] px-6 md:px-10 flex flex-col justify-center items-center md:items-start gap-4 group border-[6px] xl:border-[10px] hover:border-transparent duration-1000`}
          >
            <span
              className={`${
                theme === "dark"
                  ? "text-lightTextDesignColor "
                  : "text-darkBgColor bg-[#D2d9f3]"
              }  text-[40px] xl:text-[50px]`}
            >
              {item.icon}
            </span>
            <h3
              className={`${
                theme === "dark" ? "text-white" : "text-darkBgColor"
              } text-2xl font-bold tracking-wide translate-y-0`}
            >
              {item.title}
            </h3>
            <p className="text-base text-center md:text-left tracking-[.5px] translate-y-0">
              {item.des}
            </p>
            <div className="font-semibold w-[140px] h-10 text-left relative overflow-hidden">
              <button className="w-full text-base uppercase h-full absolute -top-0 -left-3 md:left-0 md:-translate-x-[100%] md:group-hover:-translate-x-[17%] transition-transform duration-700 openBox">
                Read More
              </button>

              <span
                className={`${
                  theme === "dark"
                    ? "bg-lightTextDesignColor"
                    : "bg-darkBgColor"
                } w-[40px] lg:w-full h-[2px] inline-flex absolute bottom-0 -right-2 md:left-0 top-[50%] translate-y-[50%] md:translate-y-[60%] lg:-translate-x-[70%] md:group-hover:translate-x-[98px] transition-transform duration-700`}
              ></span>
            </div>
          </div>
        ))}
      </div>
      {/*  ===================================================================
                              Details Box start here 
      ====================================================================== */}

      <motion.div
        initial={{ y: 100, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.2,
          y: { type: "spring", stiffness: 30, duration: 0.2 },
        }}
        className="fixed w-full h-screen top-9 left-0 right-0 z-10 hidden justify-center items-center box"
      >
        {loading ? (
          <div
            className={`${
              theme === "dark" ? "bg-white" : "bg-darkBgColor"
            } w-[80%] mdl:w-[70%] h-[20vh] mx-auto fixed boxArea flex items-center justify-center -mt-32`}
          >
            <h2
              className={`${
                theme === "dark" ? "text-darkBgColor" : "text-white"
              } text-xl font-semibold tracking-wide flex items-center gap-4`}
            >
              <span>
                <ImSpinner9 className="w-12 h-12 animate-spin text-lightTextDesignColor" />
              </span>
              {servicesItem.title} is loading...
            </h2>
          </div>
        ) : (
          <>
            <div
              className={`${
                theme === "dark" ? "bg-white" : "bg-darkBgColor"
              } w-[90%] h-[85vh] mx-auto fixed boxArea`}
            >
              <div className="w-full h-full">
                <div
                  className={`${
                    theme === "dark"
                      ? " bg-gray-100 text-darkBgColor"
                      : "bg-darkBgColor text-white"
                  } flex flex-col px-10 py-4 gap-2 h-40  border-b-[1px] border-b-lightTextDesignColor`}
                >
                  <span
                    className={`${
                      theme === "dark"
                        ? "text-lightTextDesignColor bg-lightTextColor"
                        : "text-lightTextDesignColor bg-[#D2d9f3]"
                    }  text-[40px] xl:text-[50px] w-20 h-20  flex justify-center items-center`}
                  >
                    {servicesItem.icon}
                  </span>
                  <h2 className="text-3xl font-semibold underline underline-offset-[8px] decoration-[1px]">
                    {servicesItem.title}
                  </h2>
                </div>
                <div className="w-full h-[62vh] flex gap-6 pt-4 px-4 overflow-y-scroll scrollbarHide">
                  <div className="w-[400px] lgl:inline-flex hidden h-full overflow-y-scroll scrollbarHide px-6">
                    <img
                      className={`${
                        servicesItem.imgSrc
                          ? "w-full h-[1200px] object-cover"
                          : "w-full h-auto object-contain"
                      } `}
                      src={servicesItem.imgSrc}
                      alt="servicesItem"
                    />
                  </div>
                  <div className="w-full lgl:w-3/5 h-full flex flex-col gap-2">
                    <div
                      className={`${
                        theme === "dark" ? "text-darkBgColor" : "text-gray-300"
                      } w-full border-b-[1px] flex flex-col gap-2 border-b-lightTextDesignColor  pb-2`}
                    >
                      <p className="text-base font-titleFont font-medium">
                        {servicesItem.servicesDes}
                      </p>
                      <p className="text-lg font-semibold tracking-wide">
                        {servicesItem.servicesOffer}
                      </p>
                      <a
                        href={servicesItem.website}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <p
                          className={`${
                            theme === "dark" ? "text-gray-700" : "text-gray-200"
                          } flex items-center gap-2 text-base  underline`}
                        >
                          <span className="text-darkBgColor">
                            <BsGlobe />
                          </span>
                          {servicesItem.website}
                        </p>
                      </a>
                    </div>
                    <div
                      className={`${
                        theme === "dark" ? "text-black" : "text-white"
                      } flex flex-col mdl:flex-row gap-1 mdl:gap-10`}
                    >
                      <div className="h-auto lgl:h-72 flex flex-col">
                        <h3 className="text-xl mb-2 font-semibold underline underline-offset-4 decoration-[1px]">
                          Services Included
                        </h3>

                        <ul className="flex flex-col gap-1 text-base tracking-wide font-titleFont">
                          {includedInfo?.map((item) => (
                            <li
                              key={item._id}
                              className="flex items-center gap-2 hover:text-blue-600 group cursor-move duration-200"
                            >
                              <span>
                                <BsCircleFill className="w-3 h-3 text-lightTextDesignColor group-hover:text-blue-600 duration-200" />
                              </span>
                              {item.title}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="h-auto lgl:h-72 flex flex-col">
                        <h3 className="text-xl mb-2 font-semibold underline underline-offset-4 decoration-[1px]">
                          Services Categories
                        </h3>

                        <ul className="flex flex-col gap-1 text-base tracking-wide font-titleFont">
                          {categoriesInfo?.map((item) => (
                            <li
                              key={item._id}
                              className="flex items-center gap-2 hover:text-blue-600 group cursor-move duration-200 "
                            >
                              <span>
                                <BsCircleFill className="w-3 h-3 text-lightTextDesignColor group-hover:text-blue-600 duration-200 " />
                              </span>
                              {item.title}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                onClick={handleBoxClose}
                className="absolute top-4 right-4 text-white bg-red-500 hover:bg-red-600 duration-300 cursor-pointer text-2xl closeBox"
              >
                <CgClose />
              </span>
            </div>
          </>
        )}
      </motion.div>

      {/*  ===================================================================
                              Details Box end here 
      ====================================================================== */}
    </div>
  );
};

export default MyServices;
